import { IPaginationParams } from '../../../../types';
import { useQuery } from 'react-query';
import {
  getAllRecognitionGroupByLicenseAsync,
  getAllRecognitionGroupByLicenseCountAsync,
} from '../../index';
import { IRecognitionGroupFilterParams } from '../../types';

export const useGetAllRecognitionGroupByLicenseAsync = (
  pagination: IPaginationParams,
  filter: IRecognitionGroupFilterParams,
) =>
  useQuery([`recognitionGroups${pagination.pageNumber}`, pagination], {
    keepPreviousData: true,
    staleTime: 1000 * 60,
    queryFn: () => getAllRecognitionGroupByLicenseAsync({ pagination, filter }),
  });

export const useGetAllRecognitionGroupByLicenseCountAsync = (
  pagination: IPaginationParams,
  filter: IRecognitionGroupFilterParams,
) =>
  useQuery([`recognitionGroupsCount${pagination.pageNumber}`, pagination], {
    keepPreviousData: true,
    staleTime: 1000 * 60,
    queryFn: () => getAllRecognitionGroupByLicenseCountAsync(filter),
  });
